import TemplateNames from '../email-messages/TemplateNames';
import MarketingSubscriptionSources from '../followers/MarketingSubscriptionSources';

export default {
  title: 'Markkinoinnin yleiskatsaus',
  tiles: {
    followers: 'Seuraajat',
    delivered_messages: 'Toimitetut viestit',
    open_rate: 'Avausprosentti',
    click_rate: 'Napsautussuhde',
    spam_report_rate: 'Roskapostiraporttien osuus',
    unsubscribe_rate: 'Tilauksen peruutusten osuus',
  },
  subscriprion_sources_table: {
    source_names: MarketingSubscriptionSources,
    columns: {
      subscription_source: 'Tilauksen lähde',
      count: 'Määrä',
      percentage: 'Prosenttiosuus',
    },
  },
  templates_table: {
    template_names: TemplateNames,
    columns: {
      template: 'Malli',
      delivered: 'Toimitettu',
      open_rate: 'Avausprosentti',
      click_rate: 'Napsautussuhde',
      spam_report_rate: 'Roskapostiraporttien osuus',
      unsubscribe_rate: 'Tilauksen peruutusten osuus',
    },
  },
  labels: {
    no_data: 'Ei tietoja',
  },
  toasts: {
    failed_to_load_data: 'Tietojen lataaminen epäonnistui',
  },
};
